import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import {
  jssPreset,
  StylesProvider
} from '@mui/styles'
import { create } from "jss";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";

import { Node } from "./components/Node";
import theme from "./theme";
import i18n from "./i18n";
import { I18nextProvider, useTranslation } from "react-i18next";
import {
  MessageBoxContextProvider,
  NodeContextProvider,
} from "@dispatcher-stratus/stratus-react";
import { INITIAL_NODE_CONFIG } from "./interfaces";
import DisableContextAndShortcuts from "./components/DisableContextAndShortcuts";

function App() {
  const { t } = useTranslation("translation", { i18n });
  const routing = (
    <I18nextProvider i18n={i18n}>
      <Router>
        <NodeContextProvider
          configDefaults={INITIAL_NODE_CONFIG}
          windowOptions={{
            title: t("Form Selector"),
          }}
        >
          <MessageBoxContextProvider>
            <Routes>
              <Route path="/client/node" element={
                <Node />
              } />
              <Route path="/"  element={
                <Navigate to="/client/node" replace />
              }/>
            </Routes>
          </MessageBoxContextProvider>
        </NodeContextProvider>
      </Router>
    </I18nextProvider>
  );
  return (
    <StylesProvider jss={jss}>
      <DisableContextAndShortcuts />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {routing}
      </ThemeProvider>
    </StylesProvider>
  );
}
const jss = create({
  ...jssPreset(),
  // Define a custom insertion point that JSS will look for when injecting the styles into the DOM.
  insertionPoint: document.getElementById("jss-insertion-point")!,
});
export default App;
